import type { Story } from '@/store/story-types'

export const CURATION_COMMERCE_STORY: Story = {
  id: 'curation-commerce',
  name: 'CURATED — Mina\'s Picks',
  narrative: 'An influencer curation commerce store where a curator handpicks products, writes personal reviews, and fans can browse, add to cart, and purchase recommended items.',
  goals: ['Showcase curated products', 'Provide product details', 'Manage shopping cart', 'Complete checkout', 'Confirm orders'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 4,
      linkedPageId: 'home',
      description: 'Curator hero and curated product grid',
      blockRef: { category: 'commerce', blockId: 'curator-hero' },
    },
    {
      id: 'pg-product-detail',
      title: 'Product Detail',
      order: 1,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'product-detail',
      description: 'Individual product page with images, description, and add-to-cart',
      blockRef: { category: 'commerce', blockId: 'product-detail' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 2,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'cart',
      description: 'Shopping cart with item list, quantity controls, and total',
      blockRef: { category: 'commerce', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout',
      title: 'Checkout',
      order: 3,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'checkout',
      description: 'Checkout form with shipping and payment details',
      blockRef: { category: 'commerce', blockId: 'checkout' },
    },
    {
      id: 'pg-order-confirmation',
      title: 'Order Confirmed',
      order: 4,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'order-confirmation',
      description: 'Order confirmation with summary and tracking info',
      blockRef: { category: 'commerce', blockId: 'order-confirmation' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Curated Products',
      description: 'Visitor browses the curator\'s handpicked products',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the curator hero and a grid of curated products are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Product Detail',
      description: 'Visitor views a product\'s detail page',
      steps: [
        { type: 'given', text: 'the visitor is browsing the product grid' },
        { type: 'when', text: 'they tap on a product card' },
        { type: 'then', text: 'the product detail page shows images, description, price, and an add-to-cart button', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Add to Cart',
      description: 'Visitor adds a product to the cart',
      steps: [
        { type: 'given', text: 'the visitor is on a product detail page' },
        { type: 'when', text: 'they tap Add to Cart' },
        { type: 'then', text: 'the product is added and the cart badge updates', linkedPageId: 'product-detail', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Review Cart',
      description: 'Visitor reviews items in the cart',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart' },
        { type: 'when', text: 'they navigate to the Cart page' },
        { type: 'then', text: 'all cart items with quantities, prices, and a total are displayed', linkedPageId: 'cart' },
        { type: 'and', text: 'they can update quantities or remove items', linkedFlowId: 'updateCartItem' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Complete Checkout',
      description: 'Visitor completes the purchase',
      steps: [
        { type: 'given', text: 'the visitor taps Checkout from the cart' },
        { type: 'when', text: 'they fill in shipping and payment details', linkedPageId: 'checkout' },
        { type: 'then', text: 'the order is placed and a confirmation page is shown', linkedPageId: 'order-confirmation', linkedFlowId: 'placeOrder' },
      ],
    },
  ],
}
